import { defineComponent as i, openBlock as a, createElementBlock as o, mergeProps as p, unref as e, renderSlot as Z, createElementVNode as H, createCommentVNode as u } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, g = { key: 1 }, f = { key: 2 }, k = { key: 3 }, h = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconList"
}, V = /* @__PURE__ */ i({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const s = l, { bind: r, weight: n } = M(s);
    return (d, t) => (a(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      Z(d.$slots, "default"),
      e(n) === "bold" ? (a(), o("g", m, t[0] || (t[0] = [
        H("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (a(), o("g", g, t[1] || (t[1] = [
        H("path", {
          d: "M216,64V192H40V64Z",
          opacity: "0.2"
        }, null, -1),
        H("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(n) === "fill" ? (a(), o("g", f, t[2] || (t[2] = [
        H("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (a(), o("g", k, t[3] || (t[3] = [
        H("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : e(n) === "regular" ? (a(), o("g", h, t[4] || (t[4] = [
        H("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(n) === "thin" ? (a(), o("g", w, t[5] || (t[5] = [
        H("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  V as default
};
